import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const InstructionsLoadingKeys = {
  create: "CREATE_INSTRUCTION",
  delete: "DELETE_INSTRUCTION",
  getInstructions: "GET_INSTRUCTIONS"
};

const initialState = {
  instructions: [],
  loading: false,
  loadingKeys: [],
  error: null
};

// Async thunks
export const getInstructionsById = createAsyncThunk(
  'instructions/getInstructionsById',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(`/api/v1/instructions/${id}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to get instructions');
    }
  }
);

export const createInstructions = createAsyncThunk(
  'instructions/create',
  async ({ creationData }, { rejectWithValue, dispatch }) => {
    try {
        const { id, newInstructions } = creationData
        const { data } = await axios.post('/api/v1/instructions', { newInstructions });
        dispatch(getInstructionsById({ id }));
        return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to create instruction');
    }
  }
);

export const deleteInstruction = createAsyncThunk(
  'instructions/delete',
  async ({ id, idToDelete }, { rejectWithValue, dispatch }) => {
    try {
      await axios.delete(`/api/v1/instructions/${idToDelete}`);
      dispatch(getInstructionsById({ id }));
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to delete instruction');
    }
  }
);

const instructionsSlice = createSlice({
  name: 'instructions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInstructionsById.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, InstructionsLoadingKeys.getInstructions];
      })
      .addCase(getInstructionsById.fulfilled, (state, action) => {
        state.loading = false;
        state.instructions = action.payload?.data || [];
        state.error = null;
        state.loadingKeys = state.loadingKeys.filter(key => key !== InstructionsLoadingKeys.getInstructions);
      })
      .addCase(getInstructionsById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = state.loadingKeys.filter(key => key !== InstructionsLoadingKeys.getInstructions);
      })
      .addCase(createInstructions.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, InstructionsLoadingKeys.create];
      })
      .addCase(createInstructions.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.loadingKeys = state.loadingKeys.filter(key => key !== InstructionsLoadingKeys.create);
      })
      .addCase(createInstructions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = state.loadingKeys.filter(key => key !== InstructionsLoadingKeys.create);
      })
      .addCase(deleteInstruction.pending, (state) => {
        state.loading = true;
        state.loadingKeys = [...state.loadingKeys, InstructionsLoadingKeys.delete];
      })
      .addCase(deleteInstruction.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
        state.loadingKeys = state.loadingKeys.filter(key => key !== InstructionsLoadingKeys.delete);
      })
      .addCase(deleteInstruction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.loadingKeys = state.loadingKeys.filter(key => key !== InstructionsLoadingKeys.delete);
      });
  }
});

export const {} = instructionsSlice.actions;
export default instructionsSlice.reducer; 